import React from 'react';
import {
  useLocation,
} from 'react-router';
import {
  images,
} from '../../../../assets/image';
import {
  WidgetProps,
} from './types';
import styles from './styles.module.scss';

const AccountControlWidget: React.FC<WidgetProps> = (props: WidgetProps) => {
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);

  const paramLang = queryParams.get('lang');

  const {
    widgetParams,
    defaultPaddings,
  } = props;

  return (
    <div
      style={defaultPaddings}
      className={styles.accountControl}
    >
      <div
        style={defaultPaddings}
        className={styles.headerInfo}
      >
        <img src="https://picsum.photos/200" alt="profile pic" />
        <div className={styles.header}>
          {
            paramLang === 'en'
              ? <p>Osama Shokry Ahmed</p>
              : <p>أسامة شكري أحمد</p>
          }
          <h5>
            <span className={styles.crown}>{images.goldenCrown}</span>
            {paramLang === 'en' ? 'Main member' : 'عضو رئيسي'}
          </h5>
        </div>
      </div>
      <div
        style={defaultPaddings}
        className={styles.pointsCard}
      >
        <h4>
          {
            paramLang === 'en' ? 'Remaining points' : 'النقاط المتاحة'
          }
        </h4>
        <div>
          <div className={styles.points}>
            <span>{images.goldenStar}</span>
            <h5>20K</h5>
            <span>{paramLang === 'en' ? 'Points' : 'نقطة'}</span>
          </div>
        </div>
        <div className={styles.footer}>
          <div className={styles.footerCol}>
            <div className={styles.light}>
              {paramLang === 'en' ? 'EGP to equal' : 'ما يساوي بالجنيه'}
            </div>
            <div className={styles.bold}>
              {paramLang === 'en' ? '200 EGP' : '200 جنيه'}
            </div>
          </div>
          <div className={styles.lineV} />
          <div className={styles.footerCol}>
            <div className={styles.light}>
              {paramLang === 'en' ? 'Used points' : 'النقاط المستخدمة'}
            </div>
            <div className={styles.bold}>
              {paramLang === 'en' ? '12K Points' : '12K نقطة'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountControlWidget;
